import { render, staticRenderFns } from "./EmployeeAreaForm.vue?vue&type=template&id=89e8b48c&"
import script from "./EmployeeAreaForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports